import { createFileRoute } from '@tanstack/react-router';
import { TodayOperationsPage } from '@/features/dashboard/TodayOperationsPage';

export const Route = createFileRoute('/_app/today/arrivals')({
  component: () => <TodayOperationsPage kind="arrivals" />,
});
